import React, { useState } from "react";
import { ReactComponent as BackArrow } from "../../Icons/BorderBackArrow.svg";
import {
  Box,
  Grid,
  Typography,
  Stack,
  Select,
  TextField,
  InputAdornment,
  Button,
  IconButton,
  Divider,
} from "@mui/material";
import {
  PrimaryTypography,
  SecondaryTypography,
  StyledTypography,
  StyledSecondaryTypography,
  TypographyDefault,
} from "../../Theme";
import PhoneInput from "react-phone-input-2";
import { ReactComponent as BookingCalenderIcon } from "../../Icons/BookingCalenderIcon.svg";
import { ReactComponent as UploadIcon } from "../../Icons/UploadIcon.svg";
import { ReactComponent as EditIcon } from "../../Icons/Edit.svg";
import { useNavigate } from "react-router-dom";

const AddCompany = () => {
  const [addblocks, setaddblocks] = useState({
    Company_Details: true,
    Administrator_Details: false,
    Review_Information: false,
  });
  const navigate = useNavigate();
  const blocks = [
    { status: addblocks.Company_Details, tle: "Company Details" },
    { status: addblocks.Administrator_Details, tle: "Administrator Details" },
    { status: addblocks.Review_Information, tle: "Review Information" },
  ];

  const Continue = (nxtval) => {
    setaddblocks({
      Company_Details: nxtval === "Company Details",
      Administrator_Details: nxtval === "Administrator Details",
      Review_Information: nxtval === "Review Information",
    });
  };
  const reviewstyle = {
    minHeight: "61px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "10px 0",
  };

  const CompanyDetails = () => {
    return (
      <>
        <Box mt={3} component="div" boxShadow={1} borderRadius="8px">
          <Stack
            direction="row"
            alignItems="center"
            gap="10px"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              borderRadius: "8px 8px 0 0 ",
            }}
          >
            <SecondaryTypography>Company Details</SecondaryTypography>
          </Stack>
          <Box component="form">
            <Grid
              container
              xs={12}
              gap="20px"
              sx={{
                backgroundColor: "white",
                padding: "30px 16px 30px 16px",
                border: "1px solid #E5E7EB",
              }}
            >
              <Grid xs={12} md={5.77}>
                <StyledTypography>Company Name</StyledTypography>
                <TextField
                  name="Company_Name"
                  placeholder="Enter Company Name"
                  InputProps={{ disableUnderline: true }}
                  inputProps={{ maxLength: 100 }}
                  fullWidth
                />
              </Grid>
              <Grid xs={12} md={5.77}>
                <StyledTypography>Country</StyledTypography>
                <TextField
                  name="Country"
                  placeholder="Country"
                  InputProps={{ disableUnderline: true }}
                  fullWidth
                />
              </Grid>
              <Grid xs={12} md={5.77}>
                <StyledTypography>Company Email Address</StyledTypography>
                <TextField
                  name="Company_Email_Address"
                  placeholder="Enter Company Email Address"
                  InputProps={{ disableUnderline: true }}
                  inputProps={{ maxLength: 125 }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} md={5.77}>
                <StyledTypography style={{ marginBottom: "10px" }}>
                  Contact Number
                </StyledTypography>
                <PhoneInput
                  inputProps={{ name: "phone", maxLength: 20 }}
                  country={"th"}
                  buttonStyle={{ border: "none" }}
                  inputStyle={{
                    backgroundColor: "#F9FAFB",
                    border: "none",
                    height: "46px",
                    width: "100%",
                    borderRadius: "8px",
                  }}
                  countryCodeEditable={false}
                />
              </Grid>
              <Grid xs={12}>
                <StyledTypography>Company Address</StyledTypography>
                <TextField
                  name="Company_Address"
                  placeholder="Enter Company Address"
                  InputProps={{ disableUnderline: true }}
                  inputProps={{ maxLength: 100 }}
                  fullWidth
                />
              </Grid>
            </Grid>
          </Box>
          <Stack
            direction="row"
            py={1}
            px={1}
            justifyContent="end"
            alignItems="center"
            height="60px"
            sx={{
              backgroundColor: "white",
              border: "1px solid #E5E7EB",
              borderRadius: "0 0 8px 8px ",
            }}
          >
            <Stack direction="column" justifyContent="end" alignItems="end">
              <Button
                type="button"
                sx={{ width: "fit-content" }}
                variant="Standard"
              >
                Continue
              </Button>
            </Stack>
          </Stack>
        </Box>
      </>
    );
  };

  const AdministratorDetails = () => {
    return (
      <Box mt={3} component="div" boxShadow={1} borderRadius="8px">
        <Stack
          direction="row"
          alignItems="center"
          gap="10px"
          px="16px"
          sx={{
            height: "66px",
            backgroundColor: "#FCFCFD",
            border: "1px solid #E5E7EB",
            borderRadius: "8px 8px 0 0 ",
          }}
        >
          <Box style={{ flexDirection: "column" }}>
            <SecondaryTypography>Administrator Details</SecondaryTypography>
            <TypographyDefault style={{ marginTop: "5px" }}>
              These details will be used for the purpose of signing up as a
              Super Admin.
            </TypographyDefault>
          </Box>
        </Stack>
        <Box component="form">
          <Grid
            container
            xs={12}
            gap="20px"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
              // borderRadius: "0px 0px 8px 8px",
            }}
          >
            <Grid xs={12} md={5.77}>
              <StyledTypography>Full Name</StyledTypography>
              <TextField
                name="Project_Title"
                // placeholder="Enter Project Title"
                InputProps={{ disableUnderline: true }}
                inputProps={{ maxLength: 20 }}
                fullWidth
              />
            </Grid>
            <Grid xs={12} md={5.77}>
              <StyledTypography>Email Address</StyledTypography>
              <TextField
                name="Type"
                // placeholder="Type"
                InputProps={{ disableUnderline: true }}
                fullWidth
              />
            </Grid>
          </Grid>
        </Box>
        <Stack
          direction="row"
          py={1}
          px={1}
          justifyContent="end"
          alignItems="center"
          height="60px"
          sx={{
            backgroundColor: "white",
            border: "1px solid #E5E7EB",
            borderRadius: "0 0 8px 8px ",
          }}
        >
          <Stack direction="column" justifyContent="end" alignItems="end">
            <Button type="button" variant="Standard">
              Continue
            </Button>
          </Stack>
        </Stack>
      </Box>
    );
  };
  const ReviewAccount = () => {
    return (
      <>
        <Box
          mt={3}
          component="div"
          boxShadow="0 0 3px 0 rgba(0 ,0 ,0 ,0.1)"
          borderRadius="8px 8px 0px 0px"
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              borderRadius: "8px 8px 0 0 ",
            }}
          >
            <Stack direction="row" alignItems="center" gap="10px">
              <SecondaryTypography>Company Details</SecondaryTypography>
            </Stack>
            <Button
              sx={{
                width: "83px",
                height: "36px",
                padding: "8px 6px 8px 14px",
              }}
              variant="outlined"
            >
              {" "}
              Edit{" "}
              <IconButton sx={{ paddingLeft: "10px" }}>
                {" "}
                <EditIcon width="14px" />
              </IconButton>
            </Button>
          </Stack>
          <Grid
            container
            xs={12}
            gap="2.8%"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
            }}
          >
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>
                Company Name
              </StyledSecondaryTypography>
              <TypographyDefault>
                Singapore Land Group Pte Ltd
              </TypographyDefault>
            </Grid>
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>Country</StyledSecondaryTypography>
              <TypographyDefault>Singapore</TypographyDefault>
            </Grid>
            <Divider
              sx={{
                borderTop: "1px solid #F3F4F6",
                width: "100%",
                marginTop: "10px",
              }}
            />
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>
                Company Email Address
              </StyledSecondaryTypography>
              <TypographyDefault>sgcontact@singaporeland.com</TypographyDefault>
            </Grid>
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>
                Contact Number
              </StyledSecondaryTypography>
              <TypographyDefault>+65 9890 4903</TypographyDefault>
            </Grid>
            <Divider
              sx={{
                borderTop: "1px solid #F3F4F6",
                width: "100%",
                marginTop: "10px",
              }}
            />
            <Grid xs={12} sm={5.8} sx={reviewstyle}>
              <StyledSecondaryTypography>
                Company Address
              </StyledSecondaryTypography>
              <TypographyDefault>
                50 Raffles Pl, #21-01/06 Singapore Land Tower, Singapore 048623
              </TypographyDefault>
            </Grid>
          </Grid>
          <Stack
            direction="row"
            py={1}
            px={1}
            justifyContent="end"
            alignItems="center"
            height="60px"
            sx={{
              backgroundColor: "white",
              border: "1px solid #E5E7EB",
              borderRadius: "0 0 8px 8px ",
            }}
          >
            <Stack direction="column" justifyContent="end" alignItems="end">
              <Button
                type="button"
                sx={{ width: "fit-content" }}
                variant="Standard"
              >
                Submit
              </Button>
            </Stack>
          </Stack>
        </Box>
      </>
    );
  };

  return (
    <>
      <Box>
        <BackArrow
          onClick={() => navigate("/company")}
          style={{ marginBottom: "20px", cursor: "pointer" }}
        />
        <PrimaryTypography>Add New Company</PrimaryTypography>
      </Box>
      <Box sx={{ marginTop: "30px" }} display="flex" gap="1.5%" mb={5}>
        {blocks.map((itm) => (
          <Box
            key={itm.tle}
            onClick={() => Continue(itm.tle)}
            sx={{
              borderTop: itm.status ? "3px solid #0E4965" : "3px solid #D2D6DB",
              width: "33.3%",
              color: itm.status ? "#0E4965" : "#D2D6DB",
              cursor: "pointer",
            }}
          >
            <Typography
              sx={{
                fontWeight: "500",
                fontSize: "12px",
                color: itm.status ? "#0E4965" : "#9DA4AE",
                padding: "10px 0 0 0",
              }}
            >
              {itm.tle}
            </Typography>
          </Box>
        ))}
      </Box>
      {addblocks.Company_Details && <CompanyDetails />}
      {addblocks.Administrator_Details && <AdministratorDetails />}
      {addblocks.Review_Information && <ReviewAccount />}
    </>
  );
};

export default AddCompany;
